import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '数据概览', icon: 'el-icon-s-data' }
    }]
  },
  {
    path: '/users',
    component: Layout,
    children: [{
      path: '',
      name: 'Users',
      component: () => import('@/views/users/index'),
      meta: { title: '用户管理', icon: 'el-icon-user' }
    }]
  },
  {
    path: '/cities',
    component: Layout,
    children: [{
      path: '',
      name: 'Cities',
      component: () => import('@/views/cities/index'),
      meta: { title: '城市管理', icon: 'el-icon-office-building' }
    }]
  },
  {
    path: '/peaks',
    component: Layout,
    children: [{
      path: '',
      name: 'Peaks',
      component: () => import('@/views/peaks/index'),
      meta: { title: '山峰管理', icon: 'el-icon-location-outline' }
    }]
  },
  {
    path: '/checkins',
    component: Layout,
    children: [{
      path: '',
      name: 'Checkins',
      component: () => import('@/views/checkins/index'),
      meta: { title: '打卡记录', icon: 'el-icon-check' }
    }]
  },
  {
    path: '/rankings',
    component: Layout,
    children: [{
      path: '',
      name: 'Rankings',
      component: () => import('@/views/rankings/index'),
      meta: { title: '排行榜', icon: 'el-icon-trophy' }
    }]
  },
  {
    path: '/feedback',
    component: Layout,
    children: [{
      path: '',
      name: 'Feedback',
      component: () => import('@/views/feedback/index'),
      meta: { title: '意见反馈', icon: 'el-icon-chat-dot-round' }
    }]
  },
  {
    path: '/config',
    component: Layout,
    redirect: '/config/banners',
    name: 'Config',
    meta: { title: '系统配置', icon: 'el-icon-setting' },
    children: [
      {
        path: 'banners',
        name: 'Banners',
        component: () => import('@/views/config/banners'),
        meta: { title: '轮播图管理' }
      },
      {
        path: 'notices',
        name: 'Notices',
        component: () => import('@/views/config/notices'),
        meta: { title: '公告管理' }
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import('@/views/config/contact'),
        meta: { title: '联系我们' }
      },
      {
        path: 'oss',
        name: 'OssConfig',
        component: () => import('@/views/config/oss'),
        meta: { title: '阿里云 OSS' }
      },
      {
        path: 'checkin',
        name: 'CheckinConfig',
        component: () => import('@/views/config/checkin'),
        meta: { title: '打卡配置' }
      },
      {
        path: 'certificate',
        name: 'CertificateTemplateList',
        component: () => import('@/views/config/certificate-list'),
        meta: { title: '证书模板列表' }
      },
      {
        path: 'certificate/:id',
        name: 'CertificateTemplateEditor',
        component: () => import('@/views/config/certificate-editor'),
        meta: { title: '编辑证书模板' },
        hidden: true
      },
      {
        path: 'legal',
        name: 'Legal',
        component: () => import('@/views/config/legal'),
        meta: { title: '协议管理' }
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
